import { render, staticRenderFns } from "./WatchScopeBanner.vue?vue&type=template&id=256da06f&scoped=true&"
import script from "./WatchScopeBanner.vue?vue&type=script&lang=js&"
export * from "./WatchScopeBanner.vue?vue&type=script&lang=js&"
import style0 from "./WatchScopeBanner.vue?vue&type=style&index=0&id=256da06f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256da06f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
